import React, { useEffect, useState } from "react";
import Select from "@atlaskit/select";
import { listBackupsForType } from "../../../redux/actions/backupRestoreActions";
import { useDispatch, useSelector } from "react-redux";
import { formatZData } from "../../../common/utils/formatter";
import { Box, Inline, Stack, xcss } from "@atlaskit/primitives";
import { setFlowLock } from "../../../redux/actions/integrationActions";
import { HelperMessage, Label } from "@atlaskit/form";
import Button from "@atlaskit/button/new";
import ConfirmModal from "../../../common/components/ConfirmModal";
import { restoreBackup, getBackupFile } from "../../../redux/actions/backupRestoreActions";
const RestoreFlow = () => {
  const flow = useSelector((state) => state.integration.flow);
  //list of bucket keys in format customerid/flow/flowid/filename.json
  const flowBackups = useSelector((state) => state.backups.flowBackups);
  const backup = useSelector((state) => state.backups.backup);

  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const [selectedBackup, setSelectedBackup] = useState(null);

  useEffect(() => {
    if (flow) {
      dispatch(listBackupsForType("flow", flow.id));
    }
  }, [flow]);

  useEffect(() => {
    if (selectedBackup?.label && backup) {
      const blob = new Blob([JSON.stringify(backup)], { type: "application/json" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${selectedBackup.label}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [backup]);

  const options = [
    ...[...(flowBackups || [])].reverse().map((key) => ({
      label: formatZData(key.split("/").pop().split(".json").shift()), // Extract filename
      value: key,
    })),
  ];
  const restoreBtn = xcss({
    marginTop: "22px",
  });
  const onConfirm = () => {
    dispatch(restoreBackup(selectedBackup?.value));
    setOpen(false);
  };
  const downloadClick = () => {
    dispatch(getBackupFile(selectedBackup?.value));
  };

  return (
    <Stack>
      <Inline space="space.100">
        <Stack>
          <Label>Restore</Label>
          <Box>
            <Select
              options={options}
              onChange={(selected) => {
                setSelectedBackup(selected);
                dispatch(setFlowLock(selected.value !== "current"));
              }}
              placeholder="Select a flow backup"
              minWidth="400px"
            />
          </Box>
          <HelperMessage>List shows the current backups for the flow</HelperMessage>
        </Stack>
        <Box xcss={restoreBtn}>
          <Button onClick={() => setOpen(true)}>Restore</Button>
        </Box>
        <Box xcss={restoreBtn}>
          <Button onClick={downloadClick}>Download</Button>
        </Box>
        <ConfirmModal
          action={"restore backup"}
          additionalDescription={
            <p>
              <b>Note:</b>
              This will <b>overwrite</b> current flow with the backup!
            </p>
          }
          targetName={selectedBackup?.label || ""}
          targetId={selectedBackup?.value}
          isOpen={isOpen}
          onAction={onConfirm}
          onClose={() => setOpen(false)}
        />
      </Inline>
    </Stack>
  );
};

export default RestoreFlow;
